/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-wrap-multilines */
import React from "react";
import { DatePicker, DatePickerProps } from "@material-ui/pickers";
import { makeStyles } from "@material-ui/core";
import CalendarTodayRoundedIcon from "@material-ui/icons/CalendarTodayRounded";
import { TextField } from "@material-ui/core";
import { Grid, Theme } from "@material-ui/core"; // createStyles
// import { renderIntoDocument } from "react-dom/test-utils";
import { createTheme as createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import { ViewModeTextField } from "../text-fields/ViewModeTextField";
// import { grey, red } from "@material-ui/core/colors";
import { IconTooltip } from "../../icons/IconTooltip";

const outerTheme = createMuiTheme({
  typography: {
    fontFamily: "'Open Sans', sans-serif !important",
    subtitle1: {
      fontSize: 12
    },
    body1: {
      fontWeight: 600,
      fontSize: 14
    },
    button: {
      fontSize: "12px",
      fontWeight: 500,
      fontStretch: "normal",
      fontStyle: "normal"
    }
  },
  overrides: {
    MuiInputLabel: {
      outlined: {
        letterSpacing: "normal",
        color: "#363b41"
      },
      formControl: {
        transform: "none !important"
      }
    },
    MuiInputBase: {
      root: {
        "&:focus": {
          borderRadius: "4px",
          border: "1px solid #cad1d7 !important"
        }
      },
      input: {
        padding: "10px",
        "&:focus": {
          borderRadius: "4px",
          border: "1px solid #cad1d7 !important"
        }
      }
    },
    MuiInput: {
      root: {
        borderBottom: "1px solid transparent"
      },
      underline: {
        "&&&&:before": {
          borderBottom: "1px solid transparent"
        },
        "&&&&:after": {
          borderBottom: "1px solid transparent"
        },
        "&&&&:hover:before": {
          borderBottom: "1px solid transparent"
        },
        "&&&&:hover:after": {
          borderBottom: "1px solid transparent"
        }
      }
    },
    MuiFormLabel: {
      root: {
        "&:focus": {
          borderColor: "#cad1d7",
          borderWidth: 1
        }
      }
    },
    MuiOutlinedInput: {
      input: {
        padding: "14px"
      },
      // adornedEnd:{
      //   justifyContent: "space-between"
      // },
      root: {
        "& $notchedOutline": {
          borderColor: "#cad1d7 !important",
          borderWidth: 1
        },
        "&:focus": {
          borderColor: "#cad1d7 !important",
          borderWidth: 1
        },
        "&:hover": {
          borderColor: "#cad1d7 !important",
          borderWidth: 1
        }
      }
    }
  }
});

const useStylesInput = makeStyles(() => ({
  labelRequired: {
    color: "#f75676",
    // marginLeft: "4px",
    paddingLeft: "3px",

    //  marginBottom: "4px",
    fontSize: "12px",
    paddingTop: 1
  },
  root: {
    "&.MuiOutlinedInput-input": {
      padding: "14.5px 14px 14.5px 14px !important"
    },
    "label + &": {
      marginTop: "6px"
    },

    "label + &.MuiInput-formControl": {
      borderRadius: 4,
      position: "relative",
      border: "1px solid",
      borderColor: "#cad1d7",
      fontSize: 14,
      padding: "3px 0px 3px 14px",
      alignSelf: "flex-end",
      width: "100%",
      color: "#323536"
    }
  },
  input: {
    borderRadius: 4,
    position: "relative",
    border: "1px solid #cad1d7",
    fontSize: 14,
    padding: "13px 12px",
    color: "#32325d",
    alignSelf: "flex-end",
    // transition: theme.transitions.create(["box-shadow"]),
    "&:focus": {
      "text-decoration-line": "none"
      // borderRadius: "4px",
      // border: "solid 1px #5e72e4 !important",
    }
  },
  labelContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    // marginTop: "1px",
    width: "100%"
  },
  labelRequiredComments: {
    color: "#f75676",
    // marginLeft: "4px",
    paddingLeft: "4px",
    fontSize: "12px",
    // marginBottom: "4px",
    marginTop: "5px"
  },
  labelInformation: {
    fontSize: 12,
    fontWeight: 600,
    color: "#8897aa",
    height: "14px",
    "&:hover": {
      color: "#5e72e4"
    }
  },
  commentBox: {
    marginTop: "20px",
    flex: "none !important",

    "& label": {
      width: "100%",
      "& div": {
        "& input": {
          marginBottom: "20px"
        }
      }
    }
  },
  iconInfo: {
    width: "16px !important",
    height: "16px !important",
    color: "#32325d",
    "&:hover": {
      color: "#5e72e4"
    }
  },
  iconCalender: {
    fontSize: "1rem !important",
    color: "#32325d"
  }
}));
const cookievalue = `; ${document.cookie}`;
// eslint-disable-next-line no-useless-concat
const parts = cookievalue.split("; " + "loginFlow" + "=");
let loginflow;
if (parts.length === 2) {
  loginflow = parts
    ?.pop()
    ?.split(";")
    ?.shift();
} else {
  loginflow = null;
}

const isLATUser = loginflow === "LAT";
export function DatePickerForm(
  props: DatePickerProps & {
    labelHeader?: string;
    valueTestId?: string;
    isViewMode?: boolean;
    editedLabel?: any;
    infoIconData?: any;
    editedData?: any;
    isRequired?: boolean;
    infoText?: string;
    onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
    style?: any;
    error?: boolean;
    helperText?: string;
    renderInput?: any;
    inputStyle?: any;
  }
) {
  const {
    style,
    valueTestId,
    error,
    label,
    isViewMode,
    infoIconData,
    editedLabel,
    isRequired,
    infoText,
    onBlur,
    editedData,
    inputStyle,
    ...remainingProps
  } = props;
  // const tempProps: { [index: string]: any } = props;
  const classes = useStylesInput();
  // const Errors = false;

  return isViewMode ? (
    <ViewModeTextField
      label={label}
      style={style}
      infoIconData={infoIconData}
      value={remainingProps.value as string}
      editedLabel={editedLabel}
      editedData={editedData}
    />
  ) : (
    <div>
      <ThemeProvider theme={outerTheme}>
        <DatePicker
          label={
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between"
              }}
            >
              <div
                style={{
                  display: "flex"
                }}
              >
                {label}
                {isRequired ? (
                  <span className={classes.labelRequired}>
                    <sup>*</sup>
                  </span>
                ) : null}
                {/* <div style={{ color: "#f75676", margin: 1 }}> *</div> */}
              </div>
              {infoText && infoText !== "" && infoIconData ? (
                <IconTooltip topic="Information" infoIconData={infoIconData} />
              ) : null}
            </div>
          }
          inputFormat="MMM dd, yyyy"
          openPickerIcon={
            <CalendarTodayRoundedIcon className={classes.iconCalender} />
          }
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...remainingProps}
          // autoOk
          // data-testid= {"selection-value"}
          renderInput={remainingProps.renderInput}
          // style={{ flex: 1, ...style }}
        />
      </ThemeProvider>
      {editedLabel && isLATUser ? (
        <TextField
          InputProps={{ classes }}
          className={classes.commentBox}
          InputLabelProps={{
            style: {
              position: "relative",
              fontWeight: 600,
              fontSize: 12,
              color: "#32325d",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis"
              // border: "1px solid #cad1d7",
            }
          }}
          onBlur={onBlur}
          label={
            <Grid
              container
              item
              xs={12}
              sm={12}
              className={classes.labelContainer}
            >
              <Grid item xs={12} md={12} sm={12} container>
                <span className={classes.labelInformation}>
                  {`Reason For Editing ${label}`}
                </span>
                {/* {required ? ( */}
                <span className={classes.labelRequiredComments}>
                  <sup>*</sup>
                </span>
                {/* ) : (
                   ""
                 )} */}
              </Grid>
            </Grid>
          }
          style={{
            flex: "none !important",
            width: "100%",
            marginTop: "20px !important",

            ...style
          }}
        />
      ) : (
        ""
      )}
    </div>
  );
}
